/*
 * @Author: your name
 * @Date: 2021-08-13 13:41:12
 * @LastEditTime: 2021-08-16 11:51:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \招聘\src\router\index.js
 */

import Vue from "vue";
import Router from "vue-router";
import "../../static/common.css";

Vue.use(Router);
let routerList = new Router({
  routes: [
    {
      path: "/",
      name: "init",
      redirect: "/login",
      component: () => import("@/project/login")
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/project/login")
    },
    {
      path: "/layout",
      name: "layout",
      redirect: "/homePage",
      component: () => import("../project/layout"),
      children: [
        {
          path: "/homePage",
          name: "homePage",
          meta: {
            name: "首页",
            rightId: ""
          },
          component: () => import("@/project/homePage")
        },
        {
          path: "/rightControl/settingRoleOpera/:id",
          name: "settingRoleOpera",
          meta: {
            name: "设置操作权限"
          },
          component: () => import("@/project/rightControl/settingRoleOpera")
        }
      ]
    },
    {
      path: "/updatePassword",
      name: "updatePassword",
      component: () => import("@/project/updatePassword")
    },
    {
      path: "*",
      name: "notFound",
      redirect: function(to) {
        sessionStorage.setItem("toPath", to.path);
        return "/layout";
      }
      //component: () => import("@/project/layout")
    }
  ]
});
export default routerList;



// WEBPACK FOOTER //
// ./src/router/index.js